export const UITextAndMessages = {
  uploadDataSetSuccessMessage: (datasetName) => {
    return `[${datasetName}] has been uploaded successfully.`;
  },
  datasetNameAlreadyUsedMessage: (datasetName) => {
    return `The name "${datasetName}" is already taken. Please choose a different name.`;
  },
  dataAnalisysFailedMessage: () => {
    return `Data Analysis failed. Please try again.`;
  },
  creatingResourcesPopUpMessage: () => {
    return `We’re spinning up cloud resources. Please give us a moment. We’re almost there.`;
  },
  batchPredictionUIText: () => {
    return `Start batch prediction using an existing model`;
  },
  createNewBatchPredictionDirectUIText: () => {
    return [
      "Start batch prediction using an existing model.",
      "Choose a dataset, select a model, upload your image folder as a zip file, then click predict to get started.",
    ];
  },
  createNewBatchPredictionRecurrentUIText: () => {
    return [
      "Create new batch prediction using existing model.",
      "Choose Dataset, Execution and Connector, click connect to periodically predict images from your cloud storage",
    ];
  },
};
